export const fonts = {
  body: 'Open Sans',
  heading: 'Noto Sans',
  label: 'Noto Sans',
}
